import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import ContextProvider from "./context/appContext";
import ShopContextProvider from "./context/shopContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ContextProvider>
      <ShopContextProvider>
        <App />
      </ShopContextProvider>
    </ContextProvider>
  </React.StrictMode>
);
